import { render, staticRenderFns } from "./BrandSantos.vue?vue&type=template&id=6377e70e&scoped=true&"
import script from "./BrandSantos.vue?vue&type=script&lang=js&"
export * from "./BrandSantos.vue?vue&type=script&lang=js&"
import style0 from "./BrandSantos.vue?vue&type=style&index=0&id=6377e70e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6377e70e",
  null
  
)

export default component.exports